export const CHEVRON_DOWN_CX = 'chevron-down-container';
export const CHEVRON_RIGHT_CX = 'chevron-right-container';
export const CHEVRON_LEFT_CX = 'chevron-left-container';
export const CHEVRON_UP_CX = 'chevron-up-container';


export const CLOSE_CX = '.close-container';

export const CHEVRON_BY_NATURE = {
    left: CHEVRON_LEFT_CX,
    right: CHEVRON_RIGHT_CX,
    top: CHEVRON_UP_CX,
    bottom: CHEVRON_DOWN_CX,
}